import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// Default: apply light theme on body before React mounts (ProfileProvider will override if user saved dark)
if (typeof document !== 'undefined' && document.body) {
  try {
    document.body.classList.add('light_theme');
    document.documentElement.setAttribute('data-theme', 'light');
  } catch (e) {}
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
      <HelmetProvider>
        <App />
      </HelmetProvider>
  </BrowserRouter >
);
reportWebVitals();
